import { Input } from '@src/design-system/input';
import { Label } from '@src/design-system/label';
import { CustomErrorMessage } from '@src/design-system/error-message';
import { ErrorMessage, useField } from 'formik';

import type { InputProps } from '@src/design-system/input';
import type { ComponentProps } from 'react';

export function Textfield({
  label,
  name,
  labelProps,
  helperText,
  hideError,
  ...props
}: {
  label?: string;
  name: string;
  labelProps?: ComponentProps<typeof Label>;
  helperText?: string;
  hideError?: boolean;
} & InputProps) {
  const [fieldProps, fieldMeta] = useField(name);

  return (
    <div>
      {label && (
        <Label
          htmlFor={name}
          {...labelProps}
        >
          {label}
        </Label>
      )}
      <Input
        id={name}
        hasError={!!fieldMeta.error && fieldMeta.touched}
        {...fieldProps}
        {...props}
      />
      {helperText ? (
        <p className='mt-1.5 text-xs text-gray-500'>{helperText}</p>
      ) : null}
      {!hideError && (
        <ErrorMessage
          name={name}
          component={CustomErrorMessage}
        />
      )}
    </div>
  );
}
